import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppConfigurationService } from '../../../configuration/app-configuration.service';
import { ApiSimpleListResponse } from '../../../webapi/models/response.model';
import { DictionaryMode } from '../../dictionary-mode.enum';
import { DictionaryType } from '../../dictionary-type.enum';
import { DictionaryServiceBase } from '../common/dictionary-service-base';
import { IActiveSubstanceTypeDictionaryModel } from './active-substance-type-dictionary.model';

@Injectable()
export class ActiveSubstanceTypeDictionaryService extends DictionaryServiceBase<IActiveSubstanceTypeDictionaryModel[]> {
  constructor(
    private httpClient: HttpClient,
    private config: AppConfigurationService
  ) {
    super();
  }

  type: DictionaryType = DictionaryType.ActiveSubstanceType;
  mode: DictionaryMode = DictionaryMode.Static;

  loadData(): Observable<IActiveSubstanceTypeDictionaryModel[]> {
    const url = `${this.config.configuration.api_url}/api/farmdata/v1/dictionaries/Pesticide/active-substances`;

    return this.httpClient.get<ApiSimpleListResponse<IActiveSubstanceTypeDictionaryModel>>(url).pipe(
      map(result =>
        result.items.map(x => {
          x.dictionaryType = DictionaryType[DictionaryType.ActiveSubstanceType];
          x.codeName = x.name;
          return x;
        })
      )
    );
  }
}
